import { render, staticRenderFns } from "./DraftListEdit.vue?vue&type=template&id=61917f0b"
import script from "./DraftListEdit.vue?vue&type=script&lang=js"
export * from "./DraftListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports